import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const postCommentEditApi = createAsyncThunk(
    'auth/postComments/Edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.publicapiAction(`edit_comment`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const postCommentEditSlice = createSlice({
    name: 'postComment Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(postCommentEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(postCommentEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(postCommentEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const postCommentEditReducer = postCommentEditSlice.reducer